// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  roleId: __t.u64().primaryKey().name("role_id"),
  worldId: __t.u64().name("world_id"),
  identity: __t.identity(),
  role: __t.string(),
  caps: __t.string(),
  grantedBy: __t.identity().name("granted_by"),
  grantedAt: __t.timestamp().name("granted_at"),
});
